import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckIcon, ClockIcon } from 'lucide-react';
import { useAssessment } from '../contexts/AssessmentContext';
import { formatClock } from '../utils/scoring';
export function TopBar() {
  const {
    startedAt,
    remaining,
    submitted,
    participantId,
    saveState
  } = useAssessment();
  const {
    pathname
  } = useLocation();
  const inSession = pathname === '/workspace' || pathname === '/reflection';
  const critical = remaining <= 300;
  return <header className="sticky top-0 z-40 w-full border-b border-slate-800 bg-slate-900" data-id="element-103" data-mp="2lsv4i03e0hw6">
      <div className="mx-auto flex h-16 max-w-[1600px] items-center gap-6 px-6" data-id="element-104" data-mp="2h2eqadrqss8r">
        <Link to="/" className="flex items-center gap-2.5" data-id="element-105" data-mp="2h0brb48m3orw">
          <span className="flex h-7 w-7 items-center justify-center rounded bg-teal-400 font-mono-num text-[13px] font-bold text-slate-900" data-id="element-106" data-mp="2c2sabwkj4xw9">
            L
          </span>
          <span className="text-[15px] font-semibold tracking-tight text-white" data-id="element-107" data-mp="34rzaezzmtvjm">
            Lentic Assessment
          </span>
        </Link>

        {participantId && <span className="rounded border border-slate-700 px-2 py-0.5 font-mono-num text-[11px] text-slate-400" data-id="element-108" data-mp="66tci3ldu7we">
            {participantId}
          </span>}

        <div className="ml-auto flex items-center gap-4" data-id="element-109" data-mp="3okk74d3uzzsc">
          {saveState === 'saved' && inSession && <span className="flex items-center gap-1.5 text-[11px] text-slate-400" data-id="element-110" data-mp="3thst6os4onyv">
              <CheckIcon className="h-3 w-3" data-id="element-111" data-mp="3elbh1vc475b9" />
              Saved
            </span>}

          {startedAt && <div className={`flex items-center gap-2 rounded-lg border px-3 py-2 font-mono-num tabular-nums ${submitted ? 'border-slate-700 bg-slate-800 text-slate-400' : critical ? 'border-red-500/40 bg-red-500/10 text-red-300' : 'border-slate-700 bg-slate-800 text-slate-200'}`} role="timer" data-id="element-112" data-mp="35ly42sos7yls">
              <ClockIcon className="h-4 w-4" data-id="element-113" data-mp="16g2hf52i27bn" />
              <span className="text-base font-semibold" data-id="element-114" data-mp="16cohs4l80c7w">{formatClock(remaining)}</span>
            </div>}
        </div>
      </div>
    </header>;
}